<template>
    <vs-sidebar class="items-no-padding" :click-not-close="desktopSidebar" :hidden-background="desktopSidebar" parent="#chat-app" id="chat-list-sidebar" v-model="chatSidebar">
        <div class="chat_sidebar">
            <!-- Аватарка, поиск -->
            <div class="chat__profile-search flex p-4">
                <div class="relative inline-flex sidebar_avatar">
                    <vs-avatar v-if="user.avatar && user.avatar.length" class="m-0 border-2 border-solid border-white" :src="user.avatar" size="40px" />
                    <vs-avatar v-else class="m-0 border-2 border-solid border-white" :text="avatarText" size="40px" />
                </div>
<!-- Временно закоментил поле поиска. Временное решение, потому что на бекенде долго менять логику.-->
<!--      Поставил type="hidden"-->
                <vs-input :placeholder="$t('search')" icon="icon-search" icon-pack="feather" v-model="search" @keydown="chatSearch" icon-no-border  class="w-full mr-3 lg:mx-5 input-rounded-full" />
<!--                <vs-input type="hidden" v-model="search" @keydown="chatSearch" icon-no-border  class="w-full mr-3 lg:mx-5 input-rounded-full" />-->
                <feather-icon @click="openContactPopup()" class="md:inline-flex ml-1 cursor-pointer text-primary" icon="EditIcon" />
                <feather-icon class="md:inline-flex lg:hidden ml-2 cursor-pointer" icon="XIcon" @click="$store.commit('chat/SET_CHAT_SIDEBAR', false)" />
            </div>

            <vs-divider class="d-theme-border-grey-light m-0" />

            <vs-tabs alignment="fixed" class="chat_tab" v-model="activeTab">
                <!-- Активные диалоги -->
                <vs-tab :label="$t('dialogues')">
                    <component
                        :is="'VuePerfectScrollbar'"
                        ref="filterScroll"
                        :class="['chat_dialog_scroll']"
                        @ps-y-reach-end="getChatDialog"
                        :settings="settings"
                        :key="$vs.rtl">
                            <ul class="chat__active-chats bordered-items">
                                <li class="cursor-pointer" @click="openDialog(dialog)" v-for="(dialog, index) in dialogDateFilter" :key="index">
                                    <ChatContact :group="dialog.is_public && true" :contact="dialog.recipient ? dialog.recipient : dialog" :dialog="dialog" />
                                </li>
                            </ul>
                            <div v-show="dialogStatus" class="vs-con-loading__container dialog_loader"></div>
                    </component>
                </vs-tab>
                <!-- Контакты -->
                <vs-tab :label="$t('contacts')">
                    <component
                        :is="'VuePerfectScrollbar'"
                        ref="filterScroll"
                        :class="['chat_dialog_scroll']"
                        @ps-y-reach-end="getContactsList"
                        :settings="settings"
                        :key="$vs.rtl">
                            <ul class="chat__active-chats bordered-items">
                                <li class="cursor-pointer" @click="createChat(contact)" v-for="(contact, index) in contacts" :key="index">
                                    <ChatContact :contact="contact" />
                                </li>
                            </ul>
                            <div v-show="contactsStatus" class="vs-con-loading__container contact_loader"></div>
                    </component>
                </vs-tab>
            </vs-tabs>

            <!-- Окно поиска -->
            <div v-if="search.length > 2" class="search_tab absolute">
                <component
                    :is="'VuePerfectScrollbar'"
                    ref="filterScroll"
                    class="chat_search_scroll"
                    :settings="settings"
                    :key="$vs.rtl">
                        <ul class="chat__active-chats bordered-items" v-if="searchResult.length">
                            <li class="cursor-pointer" @click="selectChat(item.obj)" v-for="(item, index) in searchResult" :key="`s_${ index }`">
                                <ChatContact :group="item.obj_type === 'chat' && true" :isSearch="true" :contact="item.obj" />
                            </li>
                        </ul>
                        <vs-alert class="m-2" v-if="!searchLoading && !searchResult.length" active="true">
                            {{$t('no_results')}}
                        </vs-alert>

                </component>
            </div>
        </div>
    </vs-sidebar>
</template>

<script>
import ChatContact from './ChatContact.vue'
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import {mapState} from 'vuex'

let searchId,
    openCheck = false

export default {
    data() {
        return {
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.6
            },
            page: 0,
            page2: 0,
            loading: false,
            loading2: false,
            desktopSidebar: true,
            searchLoading: false,
            searchPage: 1,
            searchStatus: true
        }
    },
    watch: {
        activeTab(val) {
            if(val === 1) {
                this.getContactsList()
            }
        },
        windowWidth () {
            this.setSidebarWidth()
        }
    },
    created: function() {
        this.setSidebarWidth()
    },
    computed: {
        ...mapState({
            contacts: state => state.chat.contacts,
            dialogs: state => state.chat.dialogs,
            contactsStatus: state => state.chat.contactsStatus,
            dialogStatus: state => state.chat.dialogStatus,
            searchResult: state => state.chat.searchResult,
            user: state => state.user.user,
            windowWidth: state => state.windowWidth
        }),
        search: {
            get() {
                return this.$store.state.chat.searchText
            },
            set(val) {
                this.$store.commit('chat/SET_SEARCH_TEXT', val)
            }
        },
        chatSidebar: {
            get() {
                return this.$store.state.chat.chatSidebar
            },
            set(val) {
                if(openCheck)
                    this.$store.commit('chat/SET_CHAT_SIDEBAR', val)
            }
        },
        activeTab: {
            get() {
                return this.$store.state.chat.sidebarTab
            },
            set(val) {
                this.$store.commit('chat/SET_TAB', val)
            }
        },
        userName() {
            // Если текущий язык английский, подставляем имя на англ
            if(this.$i18n.locale === 'en') {
                // Если имя на англ пустое, используем рус имя
                if(this.user.first_name_en)
                    return `${ this.user.last_name_en } ${ this.user.first_name_en }`
                else
                    return `${ this.user.lastName } ${ this.user.firstName } ${ this.user.middleName }`
            } else
                return `${ this.user.lastName } ${ this.user.firstName } ${ this.user.middleName }`
        },
        avatarText() {
            if(this.userName) {
                // Возвращяем инициалы пользователя
                let title,
                    text = this.userName
                const textAr = text.split(' ')
                if (textAr.length) {
                    const newTitle = []
                    textAr.forEach(item => {
                        newTitle.push(item.substr(0, 1).toUpperCase())
                    })
                    title = newTitle.join('')
                } else title = text.substr(0, 1)
                return title
            }
        },
        scrollbarTag () {
            return this.$store.getters.scrollbarTag
        },
        dialogDateFilter() {
            return this.dialogs.slice().sort((a, b) => {
                return this.$moment(a.last_sent).format('x') < this.$moment(b.last_sent).format('x') ? 1 : -1;
            })
        }
    },
    methods: {
        async selectChat(chat) {
            let query = Object.assign({}, this.$route.query)
            try {
                if(document.querySelector('.search_tab')) {
                    this.$nextTick(() => {
                        this.$vs.loading({
                            container: '.search_tab',
                            scale: 0.6
                        })
                    })
                }
                await this.$store.dispatch('chat/getCurrentChat', chat.id)
                this.openDialog(chat)
            } catch(e) {
                this.createChat(chat)
            } finally {
                this.search = ''
                this.$store.commit('chat/CLEAR_SEARCH_RESULT')
                if(query.id !== chat.id) {
                    query.id = chat.id

                    // https://developer.mozilla.org/en-US/docs/Web/API/History/pushState
                    const url = new URL(window.location.href);
                    url.searchParams.set('id', chat.id)
                    history.pushState({}, "", url);
                    // this.$router.push({query})

                    if(this.dialogs.length)
                        this.$store.commit('chat/CHANGE_ACTIVE_DIALOG_LIST', chat)
                }
            }
        },
        chatSearch($event) {
            clearTimeout(searchId)
            if($event.target.value.length > 1) {
                this.searchLoading = true
                searchId = setTimeout(async() => {
                    try {
                        this.$store.commit('chat/CLEAR_SEARCH_RESULT')
                        if(document.querySelector('.search_tab')) {
                            this.$nextTick(() => {
                                this.$vs.loading({
                                    background: 'transparent',
                                    container: '.search_tab',
                                    scale: 0.6
                                })
                            })
                        }

                        await this.$store.dispatch('chat/search', {val: $event.target.value, page: this.searchPage, activeTab: this.activeTab})
                    } catch(e) {
                    } finally {
                        this.searchLoading = false
                        if(document.querySelector('.search_tab'))
                            this.$vs.loading.close('.search_tab > .con-vs-loading')
                    }
                }, 800)
            } else
                this.$store.commit('chat/CLEAR_SEARCH_RESULT')
        },
        setSidebarWidth () {
            if (this.windowWidth < 1200) {
                this.desktopSidebar = false
                this.$store.commit('chat/SET_CHAT_SIDEBAR', false)
            } else {
                this.desktopSidebar = true
                this.$store.commit('chat/SET_CHAT_SIDEBAR', true)
            }
        },
        openContactPopup() {
            this.$store.commit('chat/CHANGE_INFO', false)
            this.$store.commit('chat/SET_CONTACT_POPUP', true)
        },
        openDialog(dialog) {
            let query = Object.assign({}, this.$route.query)
            openCheck = true

            if(Number(query.id) !== dialog.id) {
                query.id = dialog.id
                this.$router.push({query})
                this.$store.commit('chat/CHANGE_INFO', false)
                this.$store.commit('chat/SET_OPEN_DIALOG', dialog)
                this.$store.commit('chat/CHANGE_ACTIVE_DIALOG', dialog)
                if(this.windowWidth < 1200)
                    this.chatSidebar = false

                openCheck = false
            }
        },
        clearPage() {
            this.page2 = 0
        },
        async getChatDialog() {
            if(!this.loading2 && this.dialogStatus) {
                try {
                    this.loading2 = true
                    this.$nextTick(() => {
                        this.$vs.loading({
                            background: 'transparent',
                            container: '.dialog_loader',
                            scale: 0.6
                        })
                    })
                    let active = ''
                    if(this.$route.query && this.$route.query.id) {
                        active = this.$route.query.id
                    }
                    this.page2 = this.page2+1
                    // this.$store.commit('chat/UPDATE_DIALOGS_PAGE', this.page2)
                    const res = await this.$store.dispatch('chat/getDialogs', {page: this.page2, active})

                    if(!res.next)
                        this.$store.commit('chat/SET_DIALOG_STATUS', false)
                } catch(e) {

                } finally {
                    this.loading2 = false
                    this.$vs.loading.close('.dialog_loader > .con-vs-loading')
                }
            }
        },
        async createChat(contact) {
            try {
                openCheck = true
                const res = await this.$store.dispatch('chat/createChat', {
                    is_public: false,
                    name: this.$t('personal_dialogue'),
                    members: [
                        {
                            user: contact.id
                        }
                    ]
                })
                if(res) {
                    let query = Object.assign({}, this.$route.query)
                    query.id = res.id
                    this.$router.push({query})
                    this.$store.commit('chat/SET_OPEN_DIALOG', res)
                    this.$store.commit('chat/CHANGE_INFO', false)
                    this.activeTab = 0
                    if(this.windowWidth < 1200)
                        this.chatSidebar = false


                    openCheck = false
                }
            } catch(e) {

            }
        },
        async getContactsList() {
            if(!this.loading && this.contactsStatus) {
                try {
                    this.loading = true
                    this.$nextTick(() => {
                        if(document.querySelector('.contact_loader')) {
                            this.$vs.loading({
                                background: 'transparent',
                                container: '.contact_loader',
                                scale: 0.6
                            })
                        }
                    })
                    this.page = this.page+1
                    const res = await this.$store.dispatch('chat/getContacts', {page: this.page})

                    if(!res.next)
                        this.$store.commit('chat/SET_CONTACT_STATUS', false)
                } catch(e) {

                } finally {
                    this.loading = false
                    this.$vs.loading.close('.contact_loader > .con-vs-loading')
                }
            }
        }
    },
    components: {
        VuePerfectScrollbar,
        ChatContact
    }
}
</script>

<style lang="scss">
.search_tab{
    z-index: 105;
    top: 69.38px;
    height: 100%;
    width: 100%;
    left: 0;
    background: #ffffff;
    position: relative;
    .con-vs-loading{
        position: absolute;
    }
}
.chat_sidebar{
    .con-slot-tabs{
        height: calc(100% - 38px);
    }
    .chat_tab{
        height: calc(100% - 68.38px);
    }
    .vs-tabs--content{
        height: 100%;
        padding: 0px;
    }
}
.dialog_loader,
.contact_loader{
    position: relative;
    padding: 20px 0;
    .con-vs-loading{
        position: absolute;
    }
}
</style>

<style lang="scss" scoped>
.chat_sidebar{
    height: 100%;
    position: relative;
}
.chat_dialog_scroll{
    height: 100%;
}
.chat_search_scroll{
    height: calc(100% - 68.38px);
}
@media only screen and (max-width: 886px) {
    .sidebar_avatar{
        display: none!important;
    }
}
</style>
